import { useTheme } from "@mui/material/styles";
import { Box, useMediaQuery } from "@mui/material";
import PerfectScrollbar from "react-perfect-scrollbar";
import MenuList from "./MenuList";
import { drawerWidth } from "store/constant";
import { useSelector } from "react-redux";
import { filterMenuItems } from "utils/menufilter";

// ==============================|| SIDEBAR ||============================== //

const Sidebar = () => {
  const theme = useTheme();
  const matchUpMd = useMediaQuery(theme.breakpoints.up("md"));
  const maxWidth1199 = useMediaQuery("(max-width:1199px)");
  const { authState } = useSelector((state) => state.auth);

  return (
    <Box
      component="nav"
      sx={{
        flexShrink: { md: 0 },
        width: matchUpMd ? drawerWidth : "auto",
        position: "relative",
        top: "80px",
        display: maxWidth1199 ? "none" : "block",
      }}
      aria-label="mailbox folders"
    >
      <PerfectScrollbar
        component="div"
        style={{
          height: !matchUpMd ? "calc(100vh - 56px)" : "calc(100vh - 80px)",
          padding: "24px",
          boxShadow: "0px 0px 24px 0px rgba(0, 0, 0, 0.10)",
          bgcolor: theme.palette.background.default,
        }}
      >
        <MenuList menuItems={filterMenuItems(authState)} />
      </PerfectScrollbar>
    </Box>
  );
};

export default Sidebar;
